import type { IComponentController, IScope } from "angular";
import type { ISchedule } from "App/Modules/Models";
import { DayTypeFunctions } from "App/Modules/Models";
import type { Moment } from "moment-timezone";
import { utc } from "moment-timezone";

enum ResultScheduleViews {
    Calendar,
    Scheme,
}

export default class ResultScheduleComponentController implements IComponentController {
    public static $inject: string[] = ["$scope"];

    public schedule: ISchedule;

    public timeZone: string;

    public initialDate: Moment;

    public ResultScheduleViews = ResultScheduleViews;

    public view = ResultScheduleViews.Calendar;

    public dayTypes = DayTypeFunctions.WeekDaysMap();

    public showHeader = true;

    constructor(private $scope: IScope) {}

    public $onInit() {
        const date = utc().tz(this.timeZone).startOf("day");

        this.initialDate = utc(date.format("YYYY-MM-DD"));
    }
}
